<script lang="tsx">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppHeader',
})
</script>
<script lang="tsx" setup name="AppHeader">
import { computed } from 'vue'
import { NAvatar, NDropdown, NScrollbar, NPopover, NTooltip } from 'naive-ui'
import defaultAvatar from '@/assets/default-avatar.png'
import { useAuthStore, useUserStore, useWorkspaceStore } from '@/store'
import { simulateClickOutside } from '@/utils/tool'

import UserDropContent from './UserDropContent.vue'

const emits = defineEmits(['inviteMember'])

const userStore = useUserStore()

const isDropMenuShow = ref(false)
const isMenuListHover = ref(false)

function getUpperCaseFirstLetter(name: string) {
  return name.slice(0, 1).toUpperCase()
}


document.addEventListener('click', () => {
  isDropMenuShow.value = false
})
async function onUserMouseenter() {
  userStore.updateDropMenuInfo()
  simulateClickOutside()
  await nextTick()

  isDropMenuShow.value = true
}

function onUserMouseleave() {
  setTimeout(() => {
    if (!isMenuListHover.value) {
      isDropMenuShow.value = false
    }
  }, 200)
}

function onMenuListEnter() {
  isMenuListHover.value = true
}

function onMenuListLeave() {
  isMenuListHover.value = false
  onUserMouseleave()
}


const options = [
  {
    key: 'user',
    type: 'render',
    render: () => <UserDropContent onEnter={() => onMenuListEnter()} onLeave={() => onMenuListLeave()}
      onInviteMember={() => emits('inviteMember')} />
  },
]



</script>

<template>
  <NDropdown class="user-dropdown" :show="isDropMenuShow" placement="bottom-end" :options="options">
    <div class="user" @mouseenter="onUserMouseenter" @mouseleave="onUserMouseleave" @click.stop="() => { }">
      <NAvatar class="avatar" :src="userStore.userInfo.headerImg || defaultAvatar" :size="32" round
        object-fit="cover" />
    </div>
  </NDropdown>
</template>

<style lang="scss">
.user-dropdown {
  width: 280px;
  padding: 8px;
  // height: 341px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 0px rgba(47, 90, 140, 0.2);
  border-radius: 8px 8px 8px 8px;

  .user-drop-info {
    .energy-point {
      font-size: 12px;
      display: flex;
      align-items: center;

      .number {
        color: #FF4080;
        margin-right: 6px;
      }

      .text {
        color: #425466;
        margin-right: 8px;
      }
    }

    .header {
      padding-left: 20px;
      display: flex;
      // align-items: center;
      cursor: pointer;
      margin-bottom: 18px;

      .avartar {
        height: 40px;
        margin-right: 12px;
      }

      .info {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;

        .name {
          font-size: 14px;
          font-weight: 500;
          color: #242F57;
        }

        .phone {
          font-size: 12px;
          color: #425466
        }

      }

      .arrow {
        margin-right: 16px;
        width: 16px;
        height: 16px;
        background: url('./icons/arrow-right.png');
        background-size: cover;
        margin-top: 14px;
      }
    }

    .body {
      background-color: #fff;
      border-radius: 4px;
      padding: 4px;

      .item {
        border-radius: 4px;
        padding: 8px 20px;
        display: flex;
        align-items: center;

        &:hover {
          background: #F0F5FF;
          cursor: pointer;
        }

        .tag {
          margin-right: 12px;
          width: 28px;
          height: 28px;
          background: #4050FF;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          font-size: 14px;
          line-height: 28px;
        }

        .name {
          width: 180px;
          margin-bottom: 4px;
        }

        .manager-btn {
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          padding: 0 5px;
        }
      }

    }

    .create-btn {
      display: flex;
      align-items: center;
      border-radius: 4px;
      height: 48px;
      width: 100%;

      &:hover {
        background: #F0F5FF;
      }

      .icon {
        flex: 0 0 20px;
        width: 20px;
        height: 20px;
        margin-left: 24px;
        margin-right: 16px;
        background: url('./icons/create-btn.png') no-repeat;
        background-size: contain;
      }

      .name {
        color: #425466;
      }
    }

    .footer {
      margin-top: 4px;
      border-radius: 4px;
      background-color: #fff;
      padding: 4px;
      box-sizing: border-box;

      .btn {
        height: 48px;

        display: flex;
        align-items: center;
        border-radius: 4px;
        width: 100%;

        &:hover {
          background: #F0F5FF;
        }
      }

      .change-btn {
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;
          flex: 1;

          .icon {
            flex: 0 0 20px;
            width: 20px;
            height: 20px;
            margin-left: 24px;
            margin-right: 16px;
            background: url('./icons/change-workspace.png') no-repeat;
            background-size: contain;
          }
        }

        .arrow {
          margin-right: 16px;
          width: 16px;
          height: 16px;
          background: url('./icons/arrow-right.png');
          background-size: cover;
        }

      }

      .exit-btn {




        .icon {
          flex: 0 0 20px;
          width: 20px;
          height: 20px;
          margin-left: 24px;
          margin-right: 16px;
          background: url('./icons/logout-icon.png') no-repeat;
          background-size: contain;
        }

        .name {
          color: #425466;
        }
      }

    }
  }

}
</style>
